function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "clock");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Components-/-Time-/-On-Time-Copy",
  transform: "translate(0.000000, -5.000000)",
  fill: "#06273A",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 1.000000)"
}, React.createElement("path", {
  d: "M6,4 C9.3137085,4 12,6.6862915 12,10 C12,13.3137085 9.3137085,16 6,16 C2.6862915,16 0,13.3137085 0,10 C0,6.6862915 2.6862915,4 6,4 Z M6,5.125 C3.30761184,5.125 1.125,7.30761184 1.125,10 C1.125,12.6923882 3.30761184,14.875 6,14.875 C8.69238816,14.875 10.875,12.6923882 10.875,10 C10.875,7.30761184 8.69238816,5.125 6,5.125 Z M5.4375,10 L5.4375,7 C5.4375,6.68933983 5.68933983,6.4375 6,6.4375 C6.27959415,6.4375 6.51154383,6.64149026 6.55513782,6.90875958 L6.5625,7 L6.562,9.764 L8.60796461,11.7670812 C8.80322676,11.9623433 8.82492255,12.2654458 8.67305199,12.4846724 L8.60796461,12.5625763 C8.41270247,12.7578384 8.10960001,12.7795342 7.89037336,12.6276637 L7.81246948,12.5625763 L5.60225244,10.3977476 L5.54602987,10.3322052 C5.54395514,10.3293748 5.54190625,10.3265243 5.53988353,10.323654 C5.53458702,10.3162349 5.52928972,10.3083113 5.52421514,10.3002874 C5.51340872,10.2831098 5.50345412,10.2653148 5.4944699,10.2469584 C5.48724942,10.2322111 5.48089266,10.2176085 5.47518439,10.2028133 C5.4702727,10.190183 5.46563622,10.1767438 5.46150519,10.1630853 C5.45721613,10.1487309 5.4535085,10.1344032 5.45037346,10.119976 L5.44136761,10.0660467 L5.4375,10 L5.4375,10 Z",
  id: "clock"
}))));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.4fbea88c.svg";
export { ForwardRef as ReactComponent };